 export class BusRouteModel {
        busRouteID: number;

        routeNumber: string;

        routeName: string;

        routeShortName: string;

        active = true;

        busRouteCurrencies: Array<string> = [];
    }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-route-list/bus-route.model.ts